import { API, generic } from "api"

export default class QuestionnairesService {
  static show = async ({ pageState, chapterId, questionnaireId }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_QUESTIONNAIRES_SHOW_STATUS",
      stateDataKey: [
        "questionnaire",
        "questionnaire_attempt",
        "all_questionnaires",
        "chapter"
      ],
      stateErrorKey: [
        "questionnaireErrors",
        "questionnaireAttemptErrors",
        "allQuestionnairesErrors",
        "chapterErrors"
      ],
      apiEndpoint: API.students.questionnaires.show,
      apiUrlReplacements: { chapterId, questionnaireId },
      apiData: {},
      errorMessage: "Questionnaire could not be fetched"
    })
  }

  static start = async ({
    pageState,
    chapterId,
    questionnaireId,
    questionType
  }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_QUESTIONNAIRES_START_STATUS",
      stateDataKey: ["question", "questionnaire_attempt"],
      stateErrorKey: ["questionErrors", "questionnaireAttemptErrors"],
      apiEndpoint: API.students.questionnaires.start[questionType],
      apiUrlReplacements: { chapterId, questionnaireId },
      apiData: {},
      errorMessage: "Question could not be fetched"
    })
  }
}
